import { whichPrintedEnabled } from '../domain';
import { orderPrintingConfigRepository } from './orderPrintingConfig.repository';
import { runAttemptsToEnablePrinting } from './runAttemptsToEnablePrinting.helper';

import type { SetOrderPrintingConfigParams } from '../domain';

export function orderPrintingConfigService() {
  function getOrderPrintingConfig() {
    return {
      command: orderPrintingConfigRepository.readIsActivatedCommand(),
      checklist: orderPrintingConfigRepository.readIsActivatedChecklist(),
      autoPrint: orderPrintingConfigRepository.readIsActivatedAutoPrint(),
    };
  }

  function setOrderPrintingConfig(params: SetOrderPrintingConfigParams) {
    orderPrintingConfigRepository.updateIsActivatedCommand(params.command);
    orderPrintingConfigRepository.updateIsActivatedChecklist(params.checklist);
    orderPrintingConfigRepository.updateIsActivatedAutoPrint(params.autoPrint);
  }

  function validateWhichPrintedEnabled() {
    const { command, checklist } = getOrderPrintingConfig();
    return whichPrintedEnabled({
      isEnabledCommand: command,
      isEnabledChecklist: checklist,
    });
  }

  function validateAttemptsToEnablePrinting() {
    if (getOrderPrintingConfig().command) return false;
    return runAttemptsToEnablePrinting({
      attempts: orderPrintingConfigRepository.readAttemptsToEnablePrinting(),
      setAttempts: orderPrintingConfigRepository.updateAttemptsToEnablePrinting,
      removeAttempts:
        orderPrintingConfigRepository.deleteAttemptsToEnablePrinting,
      setOrderPrintingConfig,
    });
  }

  return {
    getOrderPrintingConfig,
    setOrderPrintingConfig,
    validateWhichPrintedEnabled,
    validateAttemptsToEnablePrinting,
  };
}
